// import React, { useEffect, useState, useRef, useCallback } from 'react';
// import { useSelector, useDispatch } from 'react-redux';
import { Button, Icon, Popup } from 'semantic-ui-react';
import { Field } from 'formik';
import CreatableSelect from 'react-select/creatable';
import _ from 'lodash'
import "../styles.css";
import storyPerson from '../assets/book-head-girl-a.png'
import personVariation from '../assets/variation-icon-b.png'
import { Grid } from 'semantic-ui-react';
import 'semantic-ui-css/semantic.min.css';
// import { convertMillisToHMS } from './bookFormUtilities';

export const controlStyles = () => {
  return {
    control: (baseStyles, state) => ({ ...baseStyles, borderColor: state.isFocused ? 'grey' : '#ececec', }),
    groupHeading: (base) => ({
      ...base,
      color: '#111111',
      backgroundColor: '#f7f7f7',
      padding: '2px 5px 2px 5px',
      fontSize: "1.0rem",
      fontWeight: "300",
    }),
    option: (base) => ({ ...base, padding: '2px', }),  // adjust padding as needed
  }
}

export const createOption = (inputValue) => ({
  value: inputValue !== undefined ? inputValue.toLowerCase().replace(/\W/g, '') : "",
  label: inputValue !== undefined ? inputValue : "",
});

// This component wraps around the CreatableSelect component to work with Formik
export const CreatableSelectInput = ({ field, form, options, litGrpSpecs, placeholder, ...props }) => {
  let isDisabled = false;

  // If character dropdowns are inactive, disable voice controls - (they need to assign results to a character)
  if ((!form.values.character || !form.values.characterValue) &&
    (field.name === "voiceValue" || field.name === "voice")) {
    isDisabled = true;
  }

  const onChange = (value) => {
    form.setFieldValue(field.name, value);

    // handle paired dropdowns
    switch (field.name) {
      case "character":
        form.setFieldValue('characterValue', value);
        break;
      case "characterValue":
        form.setFieldValue('character', value);
        break;
      case "voice":
        form.setFieldValue('voiceValue', value);
        break;
      case "voiceValue":
        form.setFieldValue('voice', value);
        break;
      case "booktitle":
        form.setFieldValue('titleValue', value);
        break;
      default:
        break;
    }
  }

  const handleCreate = (inputValue) => {
    const newOption = createOption(inputValue);
    form.setFieldValue(field.name, newOption);

    switch (field.name) {
      case "character":
      case "characterValue":
        if (!options.find(option => option.value === newOption.value)) {
          options.push(newOption);
        }
        form.setFieldValue('character', newOption);
        form.setFieldValue('characterValue', newOption);
        break;
      case "voice":
      case "voiceValue":
        if (form.values.character.value === undefined) break;
        const charKey = form.values.character.value.toLowerCase().replace(/\W/g, '');
        if (!litGrpSpecs.voices[charKey]) {
          litGrpSpecs.voices[charKey] = [];
        }
        litGrpSpecs.voices[charKey].push(newOption);
        form.setFieldValue('voice', newOption);
        form.setFieldValue('voiceValue', newOption);
        break;
      default:
        if (!options.find(option => option.value === newOption.value)) {
          options.push(newOption);
        }
        break;
    }
  };

  let calcClass = "defaultGap"
  if (field.name === "character") calcClass = "fullWidthMinus5";
  if (field.name === "voice") calcClass = "fullWidthMinus5Voice";

  return (
    <div className={calcClass}>
      <label className='creatableSelectLabel'>{props.label}</label>
      <CreatableSelect
        {...field}
        {...props}
        options={options}
        isDisabled={isDisabled}
        onChange={onChange}
        onCreateOption={handleCreate}
        onBlur={field.onBlur}
        placeholder={placeholder}
      />
    </div>
  );
};

export const getPopupHints = (fieldName) => {
  let hints = { instruction: "", icon: {} }
  switch (fieldName) {
    case 'characterValue':
      hints.instruction = (
        <><div className="helperPopup">
          <dl>
            <dt>Select from Literary Group List</dt>
            <dd>Click Dropdown and select desired character</dd>
            <dt>Add new character</dt>
            <dd>Type new character name, then press ENTER key to add Character to Book's list...</dd>
          </dl>
        </div>
        </>)
      hints.icon = storyPerson
      break;
    case 'voiceValue':
      hints.instruction = (
        <><div className="helperPopup">
          <dl >
            <dt >Select from Literary Group List</dt><dd>Click Dropdown and select desired character</dd>
            <dt>Add new Vocal variation</dt><dd>Type new variation label, then press ENTER key to add Variation to Charcter's emotion list...</dd>
          </dl>
        </div>
        </>)
      hints.icon = personVariation
      break;
    default:
      break;
  }
  return hints;
}

export const MyFormikPopup = ({ fieldName, options, placeholder }) => {
  let hints = getPopupHints(fieldName)
  return (
    <Popup
      flowing hoverable basic
      offset={[-8]}
      content={
        <>
          {hints.instruction}
          <Field
            name={fieldName}
            component={CreatableSelectInput}
            options={options}
            isClearable
            placeholder={placeholder}
          />
        </>
      }
      key={`${fieldName}Popup`}
      header={`${fieldName.charAt(0).toUpperCase() + fieldName.slice(1)} Selector`}
      trigger={<img src={hints.icon} style={{ height: "30px", marginTop: "25px", marginLeft: "5px", marginRight: "5px" }} alt="" />}
    />
  );
};

export const ResetButton = ({ isDirty, resetForm }) => (
  <Popup
    content={"Reset all entry fields"}
    key={"charPopup"}
    header={"Clear All Fields"}
    trigger={
      <Button type="button" disabled={!isDirty} circular icon onClick={resetForm}>
        <Icon name="refresh" />
      </Button>
    }
  />
);

export const initAllFormFields = (litGroupInitData, fieldSpecs, formik, litGroupSpecs) => {
  // Ensure litGroupSpecs.current is properly initialized
  if (!litGroupSpecs.current) {
    litGroupSpecs.current = {};
  }

  // Initialize each key in litGroupSpecs.current to an empty array if it doesn't exist
  Object.keys(fieldSpecs).forEach(key => {
    if (!litGroupSpecs.current[key]) {
      litGroupSpecs.current[key] = [];
    }
  });

  let fieldSpec = _.cloneDeep(fieldSpecs);
  const { litGroup } = litGroupInitData;

  // Iterating over keys of fieldSpecs
  Object.keys(fieldSpec).forEach((key) => {
    const currentSpec = fieldSpec[key];

    // For special case 'bookSeries'
    if (key === 'bookSeries') {
      let litGrpOption = [createOption(litGroup.name)];
      litGroupSpecs.current.bookSeries = litGrpOption;
      formik.setFieldValue('bookSeries', litGrpOption[0]);
    }
    // For special case 'literarygrouptype'
    else if (key === 'litGroupType') {
      let litGrpTypeOption = createOption(litGroup.has_lit_grp_type[0].name);
      litGroupSpecs.current.litGroupType = [litGrpTypeOption];
      formik.setFieldValue('literarygrouptype', litGrpTypeOption);
    }
    // Initialize characters
    else if (key === 'characters') {
      initCharacters(litGroupInitData, key, currentSpec, litGroupSpecs, formik);
    }
    // For other keys, check if they exist in litGroupInitData.litGroupSpecs
    else if (litGroupInitData.litGroupSpecs.hasOwnProperty(key)) {
      currentSpec.options = Object.values(litGroupInitData.litGroupSpecs[key])
        .map(x => createOption(x[currentSpec.fieldName]));

      // Setting the value in litGroupSpecs ref
      litGroupSpecs.current[key] = currentSpec.options;

      // If there are any options, set the first one as the default for the corresponding formik field
      if (currentSpec.options.length > 0) {
        formik.setFieldValue(currentSpec.keyName, currentSpec.options[0]);
      }
    }
  });
}

const initCharacters = (litGroupInitData, key, currentSpec, litGroupSpecs, formik) => {
  currentSpec.options = Object.values(litGroupInitData.litGroupSpecs[key])
    .map(x => createOption(x[currentSpec.fieldName]));
  litGroupSpecs.current[key] = currentSpec.options;

  if (currentSpec.options.length > 0) {
    formik.setFieldValue(currentSpec.keyName, currentSpec.options[0]);
    try {
      let activeCharVariations = Object.values(litGroupInitData.litGroupSpecs[key][0].has_variation);
      if (activeCharVariations.length > 0) {
        let variations = activeCharVariations.map(x => createOption(x['name']));
        litGroupSpecs.current.voices = { [currentSpec.options[0].value]: variations };
        formik.setFieldValue('voice', variations[0]);
      }
    } catch (error) {
      console.error('Error initializing characters:', error);
    }
  }
}

export const convertMillisToHMS = (millis) => {
  const hours = Math.floor(millis / 3600000);
  const minutes = Math.floor((millis % 3600000) / 60000);
  const seconds = Math.floor((millis % 60000) / 1000);
  return `${hours}h ${minutes}m ${seconds}s`;
};

export const convertHighLowToInteger = ({ high, low }) => {
  return high * 2 ** 32 + low;
}

export const formatToLocalTime = (isoString) => {
  if (!isoString) return "";
  const date = new Date(isoString);
  return date.toLocaleString();
};

export const fillVariations = (activeBookObj, statistics) => {
  if (!activeBookObj?.data?.uuid) {
    return (<div>Please Select a Story</div>);
  }

  if (!statistics.book) {
    return (<div>Smile</div>);
  }

  let foundList = [];

  let activeStats = {};
  const activeBook = _.find(statistics.book, (book) => {
    if (book.book.uuid === activeBookObj?.data?.uuid) {
      activeStats = book.bookStatistics;
      return true;
    }
    return false;
  });

  if (!activeBook) {
    return (<div>Smile</div>);
  }

  foundList = activeBook.processedVersionItems.map(item => ({
    ...item,
    version: convertHighLowToInteger(item.version)
  }));

  if (foundList.length < 1) {
    return (<div>No Versions found</div>);
  }

  foundList.sort((a, b) => {
    const fileNameA = a.fileName.toLowerCase();
    const fileNameB = b.fileName.toLowerCase();
    const versionA = a.version;
    const versionB = b.version;

    if (fileNameA < fileNameB) return -1;
    if (fileNameA > fileNameB) return 1;
    if (versionA < versionB) return -1;
    if (versionA > versionB) return 1;
    return 0;
  });
  let uniqueKeyIndex = 0; // Unique index for keys

  const fillHeader = (fileName) => (
    <>
      <Grid.Row key={`file${uniqueKeyIndex++}`} className='noPadTop noPadBottom' style={{ backgroundColor: "#ECECEC" }}>
        <Grid.Column className='listHeader' textAlign="left" width={2} style={{ fontWeight: "600" }}>Filename:</Grid.Column>
        <Grid.Column width={14} style={{ fontWeight: "600" }}>{fileName}</Grid.Column>
      </Grid.Row>
      <Grid.Row key={`hdr${uniqueKeyIndex++}`} className='noPadTop noPadBottom'>
        <Grid.Column className='listHeader' textAlign="center" width={1}>Ver</Grid.Column>
        <Grid.Column className='listHeader noPadLeft noPadRight' textAlign="center" width={2}>Time</Grid.Column>
        <Grid.Column className='listHeader noPadLeft noPadRight' textAlign="center" width={4}>Created On</Grid.Column>
        <Grid.Column className='listHeader' textAlign="center" width={4}>Thumbnail</Grid.Column>
        <Grid.Column className='listHeader noPadLeft noPadRight' textAlign="right" width={5}>Tokens: prompt | complete | total</Grid.Column>
      </Grid.Row>
    </>
  );

  const fillVersionList = (foundList) => {
    let variationList = [];
    let currentFileName = "";

    _.forEach(foundList, (item, index) => {
      if (item.fileName !== currentFileName) {
        variationList.push(fillHeader(item.fileName));
        currentFileName = item.fileName;
      }
      let timeHMS = convertMillisToHMS(item.processTime);
      variationList.push(
        <Grid.Row divided key={`verItem${uniqueKeyIndex++}`} className='flex-container noPadTop noPadBottom hover-pointer' onClick={() => { console.log('item data', item); }}>
          <Grid.Column className="" textAlign="center" width={1}>{item.version}</Grid.Column>
          <Grid.Column className="noPadLeft noPadRight" textAlign="center" width={2}>{timeHMS}</Grid.Column>
          <Grid.Column className="noPadLeft " textAlign="right" width={4}>{new Date(item.createdOn).toLocaleString()}</Grid.Column>
          <Grid.Column className="ellipsis" textAlign="left" width={4}>{item.thumbnail}</Grid.Column>
          <Grid.Column className='listHeader noPadLeft noPadRight' textAlign="right" width={5}>{item.prompt_tokens} | {item.completion_tokens} | {item.total_tokens}</Grid.Column>
        </Grid.Row>
      );
    });

    return variationList;
  };

  return (
    <Grid key={uniqueKeyIndex++} style={{ width: "700px" }}>
      <Grid.Row key={`title`} className='noPadTop noPadBottom'>
        <Grid.Column className='listHeader' style={{ fontWeight: "600" }} textAlign="center" width={9}>Book Title: {activeBookObj.data.name}</Grid.Column>
        <Grid.Column style={{ fontWeight: "600" }} textAlign="right" width={7}>Token Totals: {activeStats?.promptTokens || "0"} | {activeStats?.completionTokens || "0"} | {activeStats?.totalTokens || "0"}</Grid.Column>
      </Grid.Row>
      {fillVersionList(foundList)}
    </Grid>
  );
};
